module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Swiss-knife-48d566949c363ae8ff531bf477a0c0cb.svg";